module.exports = "<div class=\"rm-callout rm-callout-hide\" id={{target}}-rm-callout><span class=rm-callout-content>{{content}}</span></div>";